import React from 'react';
import { FinishNewsletterPopup } from '@husky-x/cc-finish-newsletter-popup';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';
import { FinishNewsletterImageForm } from '@phx-husky/cc-finish-newsletter-image-form';
import { FinishProductDifferences } from '@phx-husky/cc-finish-product-differences';
import { FinishProductsCards } from '@phx-husky/cc-finish-products-cards';

import {
  FinishNewsletterPopupMock,
  FinishProductCardsMock,
  FinishProductDifferencesKrahasimiProduktitMock,
  FinishProductDifferencesMock,
  FinishProductDifferencesPoredenjeProizvodaMock,
  FinishProductDifferencesPrimerjavaIzdelkovMock,
  FinishProductDifferencesUsporedbaProizvodaMock,
} from './custom-components-mocks';
import CustomIframeForm from './src/@husky-x/gatsby-theme-husky/components/CustomIframeForm/CustomIframeForm';
import CustomPanAnimation from './src/@husky-x/gatsby-theme-husky/components/CustomPanAnimation';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'FinishProductDifferences',
        component: () => <FinishProductDifferences {...FinishProductDifferencesMock} />,
      },
      {
        key: 'FinishProductDifferencesPoredenjeProizvoda',
        component: () => (
          <FinishProductDifferences {...FinishProductDifferencesPoredenjeProizvodaMock} />
        ),
      },
      {
        key: 'FinishProductDifferencesKrahasimiProduktit',
        component: () => (
          <FinishProductDifferences {...FinishProductDifferencesKrahasimiProduktitMock} />
        ),
      },
      {
        key: 'FinishProductDifferencesPrimerjavaIzdelkov',
        component: () => (
          <FinishProductDifferences {...FinishProductDifferencesPrimerjavaIzdelkovMock} />
        ),
      },
      {
        key: 'FinishProductDifferencesUsporedbaProizvoda',
        component: () => (
          <FinishProductDifferences {...FinishProductDifferencesUsporedbaProizvodaMock} />
        ),
      },
      {
        key: 'FinishProductCards',
        // @ts-expect-error - cardsStyle in ProdCards is coded as set of specified strings - mocks provides those strings, but guardtypes them as 'string'
        component: () => <FinishProductsCards {...FinishProductCardsMock} />,
      },
      {
        key: 'FinishNewsletterPopup',
        component: () => <FinishNewsletterPopup {...FinishNewsletterPopupMock} />,
      },
      {
        key: 'custom_finish_newsletter_image_form',
        component: FinishNewsletterImageForm,
      },
      {
        key: 'CustomIframeForm',
        component: CustomIframeForm,
      },
      {
        key: 'FinishCouponPanAnimation',
        component: CustomPanAnimation,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
